import React from 'react'
import Titulos from './Titulos'
import Botones from './Botones'
import TextoEnriquecido from './TextoEnriquecido'

const BannerSecundario = (props) => {
    return (
        <div className='banner-secundario-componente'>
            <Titulos {...props} />
            <TextoEnriquecido  {...props} />
            <Botones {...props} />
        </div>
    )
}

export default BannerSecundario